"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidNorwegianOrganisationNumber = void 0;
const Mod11Validator_1 = require("../Mod11Validator");
const isValidNorwegianOrganisationNumber = (value) => /^[8|9]\d{8}$/.test(value) && (0, Mod11Validator_1.isValidCheckDigit)(value);
exports.isValidNorwegianOrganisationNumber = isValidNorwegianOrganisationNumber;
//# sourceMappingURL=index.js.map